<template>
	<div>
		<header class="home-head">
			<nav class="container container-head">
				<div class="row">
					<div class="col-xs-7  col-sm-8 logo-container-head">
						<router-link to="/">
							<img
								class="img-responsive logo-head"
								src="@/assets/images/eas-head.svg"
								alt="EAS"
							/>
						</router-link>
					</div>
					<div class="col-xs-5 col-sm-4 top-nav-container">
						<!-- Member dropdown -->
						<b-dropdown class="dropdown btn-group">
							<router-link class="btn btn-clear btn-sm" role="button" to="/">
								<i class="material-icons btn-icon-lg">home</i>
							</router-link>
							<button
								class="btn btn-clear btn-sm dropdown-toggle"
								type="button"
								id="profile"
								data-toggle="dropdown"
							>
								<i class="material-icons btn-icon-lg">account_circle</i>
							</button>
							<template
								slot="dropdown"
								class="dropdown-menu dropdown-menu-right"
								aria-labelledby="profile"
							>
								<li class="dropdown-title">{{ name }}</li>
								<li>
									<router-link to="/profile" role="button"
										>My profile</router-link
									>
								</li>
								<li v-if="isAdmin">
									<router-link to="/admin" role="button">Admin</router-link>
								</li>
								<li @click="logout">
									<router-link to="/login">Logout</router-link>
								</li>
							</template>
						</b-dropdown>
					</div>
				</div>
			</nav>
		</header>
		<div class="header-border" />
	</div>
</template>

<style lang="less" scoped>
.btn-primary {
	height: 57px;
	width: 57px;
}
</style>

<script>
import { mapGetters } from 'vuex';
import { isNull } from 'lodash/fp';

export default {
	props: {
		name: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			searchTerm: null,
		};
	},
	computed: {
		...mapGetters({ isAdmin: 'admin' }),
	},
	methods: {
		logout() {
			this.$emit('logout');
		},
		search() {
			if (!isNull(this.searchTerm)) {
				this.$router.push({
					path: '/projects',
					query: {
						searchTerm: this.searchTerm,
					},
				});
			}
		},
	},
};
</script>
